import { render, staticRenderFns } from "./poster-block.vue?vue&type=template&id=8a67d8b6&"
import script from "./poster-block.vue?vue&type=script&lang=js&"
export * from "./poster-block.vue?vue&type=script&lang=js&"
import style0 from "./poster-block.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports